import * as React from "react";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchPaginatedLookupTables } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { defaultOnError } from "util/conditional/onError";
import LookupTableParameterEdit from "components/lookup-table-parameters/LookupTableParameterEdit";
const useLoadLookupTables = () => {
  const { data } = useQuery({
    queryKey: ["lookup-tables", "all-for-parameters"],
    queryFn: () => defaultOnError(
      fetchPaginatedLookupTables({
        page: 1,
        pageSize: 0,
        query: null,
        sort: { attributeId: "name", direction: "asc" }
      }),
      "Loading lookup tables failed"
    )
  });
  return data == null ? void 0 : data.list;
};
const useValidation = ({ onValidate, tableKey, lookupTable, idx }) => {
  useEffect(() => {
    const _validationState = tableKey !== void 0 && tableKey !== "" ? ["success"] : ["error", "Lookup table key is required"];
    onValidate(idx, { key: _validationState });
    return () => onValidate(idx, { key: ["success"] });
  }, [tableKey, idx, onValidate]);
  useEffect(() => {
    const _validationState = lookupTable !== void 0 && lookupTable !== "" ? ["success"] : ["error", "Please select a lookup table"];
    onValidate(idx, { lookupTable: _validationState });
    return () => onValidate(idx, { lookupTable: ["success"] });
  }, [lookupTable, idx, onValidate]);
};
const LookupTableParameterForm = ({
  idx,
  onChange,
  validationState,
  parameter,
  onValidate
}) => {
  const { key: tableKey, lookupTable } = parameter;
  const lookupTables = useLoadLookupTables();
  useValidation({ onValidate, tableKey, lookupTable, idx });
  return /* @__PURE__ */ React.createElement(
    LookupTableParameterEdit,
    {
      onChange,
      lookupTables,
      identifier: idx,
      parameter,
      defaultExpandHelp: false,
      validationState
    }
  );
};
export default LookupTableParameterForm;
